//-------------MONITORING_COPY--------------
import {Pane, PaneProps} from "evergreen-ui";
import React from "react";
import {MemoStationSearchByNameMonitoring} from "./StationSearchByNameMonitoring";
import {MemoRegionSelectMonitoring} from "../../Selectors/RegionSelectMonitoring";
import {MemoCategoryTypeSelectMonitoring} from "../../Selectors/CategoryTypeSelectMonitoring";
import {useSelectedRegionMonitoring} from "../../Hooks/useSelectedRegionMonitoring";
import {useStationSearchTextMonitoring} from "../../Hooks/useStationSearchTextMonitoring";
import {useSelectedTypeIdMonitoring} from "../../Hooks/useSelectedTypeIdMonitoring";

export const StationsFiltersMonitoring = (props: PaneProps) => {
    const { regionId, onSelectRegion } = useSelectedRegionMonitoring();
    const { searchText, onChangeSearchText } = useStationSearchTextMonitoring();
    const { typeId, onSelectType } = useSelectedTypeIdMonitoring();

    return (
        <Pane display="grid" gap=".2rem" gridTemplateColumns="1fr repeat(2, 1fr) max-content" {...props}>
            <MemoStationSearchByNameMonitoring debounceDelay={800} text={searchText} updateText={onChangeSearchText} />
            <MemoRegionSelectMonitoring selected={regionId} onSelect={onSelectRegion} />
            <MemoCategoryTypeSelectMonitoring selected={typeId} onSelect={onSelectType} />
        </Pane>
    );
};
export const MemoStationsFiltersMonitoring = React.memo(StationsFiltersMonitoring);
MemoStationsFiltersMonitoring.displayName = 'MemoStationsFiltersMonitoring';
export default StationsFiltersMonitoring;